module.exports = __webpack_public_path__ + "static/img/0000志愿者2.ee20ec0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000志愿者2.jpg
// module id = /H4B
// module chunks = 0